<template>
  <div class="home main-section">
    <div class="section-card-img section-1">
      <div class="section-1-wrapper">
        <a href="#section-2">
          <img src="@/assets/image/year26-qz/btn1@2x.webp" alt="" />
        </a>
      </div>
    </div>
    <div class="section-card-img section-2" id="section-2">
      <div class="section-2-wrapper">
        <form class="qz-form" id="input-form">
          <div class="qz-form-control">
            <label class="qz-label" for="input_name">姓名</label>
            <input
              class="qz-input"
              type="text"
              id="input_name"
              placeholder="请输入您的姓名"
              v-model="name"
            />
          </div>
          <div class="qz-form-control qz-birth" style="position: relative">
            <label class="qz-label" for="input_date">生日</label>
            <input
              type="text"
              class="qz-input"
              aria-label=""
              id="input_date"
              v-model="birthday"
              placeholder="请选择您的生日"
              readonly
              @click.prevent="showModal = true"
            />
            <button
              class="qz-birth-btn"
              type="button"
              @click.prevent="showModal = true"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.2 4V3C15.2 2.44772 15.6477 2 16.2 2C16.7523 2 17.2 2.44772 17.2 3V4.00491C19.3162 4.10912 21 5.85793 21 8V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V8C3 5.79086 4.79086 4 7 4H7.2V3C7.2 2.44772 7.64772 2 8.2 2C8.75228 2 9.2 2.44772 9.2 3V4H11.2V3C11.2 2.44772 11.6477 2 12.2 2C12.7523 2 13.2 2.44772 13.2 3V4H15.2ZM15.2 6H13.2C13.2 6.55228 12.7523 7 12.2 7C11.6477 7 11.2 6.55228 11.2 6H9.2C9.2 6.55228 8.75228 7 8.2 7C7.64772 7 7.2 6.55228 7.2 6H7C5.89543 6 5 6.89543 5 8V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V8C19 6.96291 18.2106 6.11019 17.2 6.00987C17.1947 6.55761 16.749 7 16.2 7C15.6477 7 15.2 6.55228 15.2 6ZM9 12C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H9ZM9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16H9Z"
                  fill="#6C757D"
                />
              </svg>
            </button>
          </div>
          <div class="qz-form-control">
            <label class="qz-label" for="input_time">时辰</label>
            <select
              class="qz-select"
              id="input_time"
              required
              v-model="birthHour"
            >
              <option value="" disabled selected hidden>
                请选择您的出生时辰
              </option>
              <option value="0">早子时 00:00-00:59</option>
              <option value="1">丑时 01:00-02:59</option>
              <option value="3">寅时 03:00-04:59</option>
              <option value="5">卯时 05:00-06:59</option>
              <option value="7">辰时 07:00-08:59</option>
              <option value="9">巳时 09:00-10:59</option>
              <option value="11">午时 11:00-12:59</option>
              <option value="13">未时 13:00-14:59</option>
              <option value="15">申时 15:00-16:59</option>
              <option value="17">酉时 17:00-18:59</option>
              <option value="19">戌时 19:00-20:59</option>
              <option value="21">亥时 21:00-22:59</option>
              <option value="23">晚子时 23:00-23:59</option>
            </select>
          </div>
          <div class="qz-form-control">
            <label class="qz-label" for="input_gender">性别</label>
            <select
              class="qz-select"
              id="input_gender"
              required
              v-model="gender"
            >
              <option value="" disabled selected hidden>请选择您的性别</option>
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
          </div>
          <p class="qz-info-text">为了求测试结果准确,请仔细核对资讯</p>
          <input name="year" id="year" type="hidden" value="2026" />
          <div class="qz-btn-wrapper btn-estimate">
            <img
              src="@/assets/image/year26-qz/btn2@2x.webp"
              @click="submitToPreview()"
              alt="立即测算"
            />
          </div>
          <a class="qz-history-link" @click="linkToHistory()">
            <p>查看历史订单 &gt;&gt;</p>
          </a>
        </form>
      </div>
    </div>
    <div class="section-card-img section-3"></div>
    <Teleport to="body">
      <!-- use the modal component, pass in the prop -->
      <date-picker-modal
        :show="showModal"
        :year="currentYear"
        :month="currentMonth"
        :day="currentDay"
        @modal-submit="modalSubmit"
        @close="showModal = false"
      >
      </date-picker-modal>
    </Teleport>
    <!-- 固定在底部的按钮（当 section-1 消失时显示） -->
    <div class="fixed-bottom-btn" id="fixed-bottom-btn" style="display: none">
      <a href="#section-2">
        <img src="@/assets/image/year26-qz/btn1@2x.webp" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Teleport from 'vue2-teleport'

import DatePickerModal from '@/components/DatePickerModal.vue'

import { SHI_CHEN } from '@/constants/shi-chen-list'
import { QUIZ_YEAR } from '@/constants/year-constant'

export default {
  name: 'HomeView',
  data() {
    return {
      name: null,
      currentYear: null,
      currentMonth: null,
      currentDay: null,
      birthHour: '',
      gender: '',
      showModal: false,
    }
  },
  components: { DatePickerModal, Teleport },
  mounted: function () {
    ;(function () {
      function checkSection1Visibility() {
        const section1 = document.querySelector('.section-1')
        const fixedBtn = document.getElementById('fixed-bottom-btn')

        if (!section1 || !fixedBtn) {
          return
        }

        // 获取 section-1 的位置资讯
        const rect = section1.getBoundingClientRect()
        const windowHeight =
          window.innerHeight || document.documentElement.clientHeight

        // 判断 section-1 是否完全消失在画面中（底部离开视窗顶部）
        // 当 section-1 的底部位置小于 0 时，表示完全滚出视窗上方
        if (rect.bottom < 0) {
          fixedBtn.style.display = 'flex'
        } else {
          fixedBtn.style.display = 'none'
        }
      }

      // 监听滚动事件
      let ticking = false
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            checkSection1Visibility()
            ticking = false
          })
          ticking = true
        }
      }

      // 初始化检查
      function initScrollListener() {
        checkSection1Visibility()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', checkSection1Visibility, {
          passive: true,
        })
      }

      // 确保在 DOM 加载完成后初始化
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollListener)
      } else {
        initScrollListener()
      }
    })()
  },
  methods: {
    submitToPreview: function () {
      if (this.formValid) {
        var birthday = moment(this.birthday)
        var payload = {}

        payload.name = this.name
        payload.gender = parseInt(this.gender)
        payload.birthdayYear = this.currentYear
        payload.birthdayMonth = this.currentMonth
        payload.birthdayDate = this.currentDay
        payload.birthdayHour = parseInt(this.birthHour)

        payload.quizYear = QUIZ_YEAR

        this.$store.commit('fortune/setRequestData', payload)

        this.$router.push({ name: 'Preview' })
      } else {
        if (!this.birthday || this.name == '' || this.name === null) {
          alert('请输入生日与姓名')
        } else if (this.name.length < 2 || this.name.length > 4) {
          alert('注意姓名长度为2-4的中文字符')
        } else if (this.birthHour == null) {
          alert('请选择时辰')
        } else if (this.gender == null) {
          alert('请选择性别')
        } else {
          alert('注意姓名长度为2-4的中文字符')
        }
      }
    },
    linkToHistory: function () {
      this.$router.push({ name: 'History' })
    },
    modalSubmit: function (year, month, day) {
      this.currentYear = year
      this.currentMonth = month
      this.currentDay = day
    },
  },
  computed: {
    shiChenList: function () {
      let result = { ...SHI_CHEN }
      delete result[0]
      delete result[23]
      return result
    },
    formValid: function () {
      if (this.name && !isChinese(this.name)) {
        return false
      } else if (this.birthday && this.name && this.birthHour && this.gender) {
        if (this.name.length <= 4 && this.name.length >= 2) {
          return true
        }
      }
      return false
    },

    birthday: function () {
      if (!this.currentYear || !this.currentMonth || !this.currentDay)
        return null
      return (
        this.currentYear +
        '-' +
        String(this.currentMonth).padStart(2, '0') +
        '-' +
        String(this.currentDay).padStart(2, '0')
      )
    },
  },
}

var isChinese = function (s) {
  var ret = true
  for (var i = 0; i < s.length; i++) {
    ret = ret && s.charCodeAt(i) >= 10000 //判断文本字符的unicode值
  }
  return ret
}
</script>

<style scoped>
.wrapper {
  /* Wrapper styles */
}

.main-section {
  max-width: 750px;
  margin: 0 auto;
}

.section-card-img {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
}
.section-1 {
  background-image: image-set(
    url('../assets/image/year26-qz/part1.webp') 1x,
    url('../assets/image/year26-qz/part1@2x.webp') 2x
  );
  /* 保持图片宽高比 375:810 = 1:2.16 */
  aspect-ratio: 375 / 810;
}
.section-1-wrapper {
  margin: 0 auto;
  padding: 191% 0 0;
  width: 70%;
}
.section-1-wrapper img {
  width: 100%;
  height: auto;
}
.section-2 {
  background-image: image-set(
    url('../assets/image/year26-qz/part2.webp') 1x,
    url('../assets/image/year26-qz/part2@2x.webp') 2x
  );
  aspect-ratio: 375 / 652;
  /* 让第二个元素稍微重叠第一个，消除缝隙 */
  margin-top: -2px;
}
.section-2-wrapper {
  width: 70%;
  margin: 0 auto;
  padding: 40% 0 0;
}

.qz-btn-wrapper {
  cursor: pointer;
}
.qz-history-link {
  cursor: pointer;
}
.qz-select:invalid {
  color: #9aa0a6;
}
.qz-select:invalid option {
  color: #333;
}
.section-3 {
  background-image: image-set(
    url('../assets/image/year26-qz/part3.webp') 1x,
    url('../assets/image/year26-qz/part3@2x.webp') 2x
  );
  aspect-ratio: 375 / 2435;
  /* 让第三个元素稍微重叠第二个，消除缝隙 */
  margin-top: -2px;
}

@media (min-width: 400px) {
  .section-1 {
    background-image: url('../assets/image/year26-qz/part1@2x.webp');
  }
  .section-2 {
    background-image: url('../assets/image/year26-qz/part2@2x.webp');
  }
  .section-3 {
    background-image: url('../assets/image/year26-qz/part3@2x.webp');
  }
}

/* 表单样式 */
.qz-form {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.qz-form-control {
  position: relative;
  /* margin-bottom: 20px; */
  width: 100%;
}

.qz-label {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #d32f2f;
  font-size: 16px;
  font-weight: 500;
  z-index: 1;
  pointer-events: none;
}

.qz-input,
.qz-select {
  width: 100%;
  background-color: #feecde;
  border: none;
  border-radius: 4px;
  padding: 12px 15px;
  padding-left: 70px;
  font-size: 16px;
  color: #333;
  outline: none;
  box-sizing: border-box;
}

.qz-input::placeholder {
  color: #999;
}

.qz-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 15px center;
  padding-right: 40px;
  cursor: pointer;
}

.qz-select option[value=''] {
  color: #999;
}

.qz-select:invalid {
  color: #999;
}

.qz-birth {
  position: relative;
}

.qz-birth .qz-input {
  padding-right: 50px;
  min-width: 0;
  overflow: hidden;
}

.qz-birth-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  flex-shrink: 0;
}

.qz-birth-btn svg {
  width: 20px;
  height: 20px;
}

.qz-info-text {
  text-align: center;
  color: #eebfb5;
  font-size: 15px;
  /* margin: 15px 0 20px 0; */
  font-weight: bold;
}

.open-apparent-solar-time {
  border-bottom: 1px solid #d32f2f;
  cursor: pointer;
  font-weight: bolder;
}

.qz-btn-wrapper {
  text-align: center;
  /* margin: 20px 0; */
}

.qz-btn-wrapper a {
  display: inline-block;
}

.qz-btn-wrapper img {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.qz-history-link {
  display: block;
  text-align: center;
  /* margin-top: 15px; */
  text-decoration: none;
}

.qz-history-link p {
  color: #fdead4;
  font-size: 18px;
  margin: 0;
  font-weight: bold;
}

/* 固定在底部的按钮 */
.fixed-bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 15px;
  text-align: center;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 750px;
  margin: 0 auto;
}

.fixed-bottom-btn a {
  display: inline-block;
}

.fixed-bottom-btn img {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
}
</style>
